import { Address } from 'nftx.js';
import {
  ActionItem,
  ActionList,
  ApproveActionItem,
} from '../../modules/ActionList';
import { TransactionState } from '@nftx/react';

const MigrateVToken = ({
  onCancel,
  onComplete,
  tokenAddress,
  spenderAddress,
  v2VaultSymbol,
  v3VaultSymbol,
  status,
  error,
  onMigrate,
}: {
  onCancel: () => void;
  onComplete: () => void;
  tokenAddress: Address;
  spenderAddress: Address;
  v2VaultSymbol: string;
  v3VaultSymbol: string;
  status: TransactionState;
  error: any;
  onMigrate: () => void;
}) => {
  return (
    <div>
      <ActionList
        title="Migrate VToken"
        description=""
        onCancel={onCancel}
        onComplete={onComplete}
      >
        <ApproveActionItem
          index={0}
          tokenAddress={tokenAddress}
          spenderAddress={spenderAddress}
          standard="ERC20"
          symbol={v2VaultSymbol}
          type="on-chain"
        />
        <ActionItem
          label={`Migrate v2 ${v2VaultSymbol} to v3 ${v3VaultSymbol}`}
          index={1}
          status={status}
          error={error}
          action={onMigrate}
        />
      </ActionList>
    </div>
  );
};

export default MigrateVToken;
